import React, { useState, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import CommonDashboardCard from '../../components/PartnerDashboardCard/CommonDashboardCard';
import lead_icon from '../../images/icons/lead_icon.svg';
import sanction_icon from '../../images/icons/sanction_icon.svg';
import disbursement_icon from '../../images/icons/disbursement_icon.svg';
import login_icon from '../../images/icons/login_icon.svg';
import { getBPCardsData, getPBTableDataBP } from '../../common/constants/api';
import moment from 'moment';
import CommonMbTableCard from '../../components/CommonMbTableCard/CommonMbTableCard';
import MBTableSearchBox from '../../components/CommonMbTableCard/MBTableSearchBox';
import MBTopStatusFilter from '../../components/CommonMbTableCard/MBTopStatusFilter';
import CircularProgress from '@material-ui/core/CircularProgress';
import { navigate } from 'gatsby';
import InfiniteScrollPagination from '../../common/constants/InfiniteScrollPagination';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import './MobileBPDashboard.css';

let icons = [
  { icon: lead_icon },
  { icon: login_icon },
  { icon: sanction_icon },
  { icon: disbursement_icon }
];
let cardStaticData = [
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'New Lead'
  },
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'Login'
  },
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'Sanction'
  },
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'Disbursement'
  }
];
const MobileBPDashboard = () => {
  const [cardData, setCardData] = useState([]);
  const [TableData, setTableData] = useState([]);
  const [err, setErr] = useState('');

  const [startDate, setStartDate] = useState('2020-05-01');
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [filter, setFilter] = useState({ value: 'ALL', label: 'ALL' });
  const [statusFilterList, setStatusFilterList] = useState([]);
  const [searchbar, setSearchBar] = useState('');
  const [tableLoading, setTableLoading] = useState(true);
  const MobileRef = useRef('');
  const [isFetching, setIsFetching] = useState(false);
  const searchBoxRef = useRef(null);
  const cardref = useRef(null);
  const summaryCards = useRef(null);

  function showCard() {
    let y = window.pageYOffset;
    if (y >= 143) {
      window.scrollTo({ top: '0', behavior: 'smooth' });
    }
  }
  useEffect(() => {
    function scrollListener(e) {
      const y = window.pageYOffset;
      if (y >= 143) {
        summaryCards.current.style.visibility = 'visible';
        searchBoxRef.current.style.position = 'fixed';
        searchBoxRef.current.style.top = '125px';
        searchBoxRef.current.style.left = '0px';
        searchBoxRef.current.style.right = '0px';
        searchBoxRef.current.style.zIndex = '1';
        searchBoxRef.current.style.background = '#f8f8f8';
        cardref.current.style.paddingTop = '50px';
      } else {
        summaryCards.current.style.visibility = 'hidden';
        searchBoxRef.current.style.position = 'initial';
        searchBoxRef.current.style.top = 'initial';
        searchBoxRef.current.style.left = 'initial';
        searchBoxRef.current.style.right = 'initial';
        searchBoxRef.current.style.zIndex = 'initial';
        searchBoxRef.current.style.background = 'initial';
        cardref.current.style.paddingTop = 'initial';
      }
    }
    window.addEventListener('scroll', scrollListener);

    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, []);

  useEffect(() => {
    let copyCardStaticData = [...cardStaticData];
    getBPCardsData(startDate, endDate)
      .then(res => {
        res.map((item, index) => {
          const finalDefaultData = copyCardStaticData[index]
            ? copyCardStaticData[index]
            : {};
          copyCardStaticData[index] = {
            ...finalDefaultData,
            ...item
          };
        });
        setCardData(copyCardStaticData);
      })
      .catch(err => {
        console.log(err, 'error is showing');
      });
  }, [startDate, endDate]);

  const activeFilterValue = filter.value;
  useEffect(() => {
    setIsFetching(true);
    getPBTableDataBP(
      0,
      10,
      startDate,
      endDate,
      'createdOn',
      'desc',
      activeFilterValue
    )
      .then(data => {
        setIsFetching(false);
        setTableData(data.data);
        setTableInfo(data.dataPage);
        setTableLoading(false);
      })
      .catch(err => {
        setErr(err.message);
        setIsFetching(false);
      });
  }, [startDate, endDate, activeFilterValue]);

  let finalResult = TableData;
  finalResult = finalResult.filter((each, i) => {
    let searchByNamePass = false;
    let searchByLeadIdPass = false;
    let statusFilterPass = false;
    let concateName = `${each?.name?.firstName || ''}${each?.name?.MiddleName ||
      ''}${each?.name?.lastName || ''}`;

    if (
      concateName
        .toLowerCase()
        .trim()
        .includes(searchbar.toLowerCase().trim())
    ) {
      searchByNamePass = true;
    }
    if (
      each?.leadId
        .toString()
        .trim()
        .includes(searchbar.toString().trim())
    ) {
      searchByLeadIdPass = true;
    }
    if (
      activeFilterValue.toLowerCase().trim() == 'all' ||
      activeFilterValue.toLowerCase().trim() ==
        each?.status.toLowerCase().trim()
    ) {
      statusFilterPass = true;
    }

    return (searchByNamePass || searchByLeadIdPass) && statusFilterPass;
  });

  return (
    <div>
      <div className="block md:hidden  overflow-auto max-screen">
        <Sidebar />
        <Header />
        <div
          className="relative"
          style={{
            paddingTop: '92px'
          }}
        >
          <div className="topThreeDivContainer font-roboto text-sm  font-light">
            <MBTopStatusFilter
              filter={filter}
              setFilter={setFilter}
              statusFilterList={statusFilterList}
              setStatusFilterList={setStatusFilterList}
            />
            <div
              className="SummaryCards font-normal invisible"
              onClick={showCard}
              ref={summaryCards}
            >
              Summary cards
            </div>
            <div
              className="text-black-600 font-normal"
              style={{ justifySelf: 'end', paddingRight: '10px' }}
            >
              This Month
            </div>
          </div>
          <div>
            <div className="test w-full ">
              <div className="MbcardsContainer">
                {cardData.length !== 0 &&
                  cardData.map((each, index) => {
                    return (
                      <CommonDashboardCard
                        key={index}
                        sendeach={each}
                        icons={icons[index]}
                      />
                    );
                  })}

                {!cardData ||
                  (cardData && cardData.length === 0 && (
                    <p className="text-red-300">Something went wrong</p>
                  ))}
              </div>
            </div>
            <div ref={searchBoxRef}>
              <MBTableSearchBox
                searchbar={searchbar}
                setSearchBar={setSearchBar}
              />
            </div>

            <div ref={cardref} style={{ minHeight: '590px' }}>
              {finalResult?.length !== 0 &&
                finalResult.map((each, index) => {
                  return <CommonMbTableCard key={each.leadId} each={each} />;
                })}
              {!finalResult ||
                (finalResult?.length === 0 && (
                  <div className="text-center pt-32">
                    {isFetching ? (
                      <CircularProgress />
                    ) : (
                      <p className="">There are no records to display</p>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <InfiniteScrollPagination
        Component={CommonMbTableCard}
        call_api={getPBTableDataBP}
        startDate={startDate}
        endDate={endDate}
        filter={filter}
        sortColumn="createdOn"
        sortDirection="desc"
        status={filter.value}
      />
    </div>
  );
};

export default MobileBPDashboard;
